import * as api from '@/api';
import { simpleAxiosInstance } from '@/api/config';
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState(['userData']),
        ...mapGetters(['preferredLanguage']),
    },
    methods: {
        async openTerms(url = false, showAccept = false) {
            try {
                let termsUrl = url;
                let language = this.userData && this.userData.locale && this.userData.locale !== '' ? this.userData.locale : this.preferredLanguage;
                if (language === '') language = 'en';

                const latestTerms = await api.users.getLatestTerms();
                const lastUpdated = latestTerms.data.updated_at;
                const version = latestTerms.data.version;

                if (!url) {
                    termsUrl = latestTerms.data.urls[language];
                }
                const response = await simpleAxiosInstance.get(termsUrl);
                this.$modal.show(
                    () => import(`@/views/modal/ViewTerms.vue`),
                    {
                        html: response.data,
                        showAccept: showAccept,
                        lastUpdated: lastUpdated,
                        version: version,
                    },
                    {
                        scrollable: true,
                        width: 650,
                        height: 'auto',
                        class: 'ngdialog-theme-winconnect',
                        clickToClose: !showAccept,
                    }
                );
            } catch (error) {
                console.error(error);
            }
        },
    },
};
